import React from 'react'
import {connect} from 'react-redux'
import {convertToRaw, EditorState} from 'draft-js'
import {convertFromHTML, convertToHTML} from 'draft-convert'

import '../../asset/less/component.css'
import '../../asset/less/Showcase.css'

import {Avatar, Button, Col, Divider, Form, Input, message, Modal, Row, Skeleton, Upload} from 'antd'
import {UploadOutlined} from '@ant-design/icons'

import RichTextEditor from '../../component/base/RichTextEditor'

import {uploadAvatar, uploadImage} from '../../api/amazonS3'
import {getArtistProfile, patchArtistProfile} from '../../api/artistProfiles'
import {getArtistBio, patchArtistBio, postArtistBio} from '../../api/artistBio'
import {getArtistStory, patchArtistStory, postArtistStory} from '../../api/artistStories'
import {getFileNameByUrl} from '../../app/util'
import HttpError from '../../component/base/HttpError'
import Title from 'antd/es/typography/Title'
import {withRouter} from 'react-router'
import {URL_SHOWCASE_SPOTLIGHTS, URL_WRITER_STATEMENT} from '../../const'
import Card from "antd/es/card/Card";
import BackButton from "../../component/base/BackButton";

const {confirm} = Modal

@connect((state) => ({
    //decorator, gives component access to the state
    id: state.user.info.id,
    userId: state.user.info.userId,
    artistId: state.user.info.artistId,
    email: state.user.info.email,
    siderWidth: state.style.siderWidth,
    role: state.user.info.role
}))
class ShowcaseBio extends React.Component {
    constructor(props) {
        super(props)

        this.titleText = React.createRef()
        this.bioText = React.createRef()
        this.storyText = React.createRef()
        this.mediaFormRef = React.createRef()
        this.state = {
            currTitle: '', //curr = what is on the server, used to load into the editors
            initBio: '', //JSON string
            initStory: '',
            currVideo: '',
            title: '', //the title being entered
            bio: '', //next four fields are for the preview function
            story: '',
            video: '',
            image: '',
            modalIsVisible: false, //for the Troubleshooting Modal
            previewVideo: null,
            currBioPreview: null,
            currStatementPreview: null,
            currStatementTitlePreview: null,
            avatar: '',
            loading: false,
        }
        this.is_continue = false
    }

    componentDidMount() {
        this.is_continue = false
        if (this.props.userId == null) return
        this.setState({loading: true})
        if (this.props.userId && this.props.artistId) {
            Promise.all([
                getArtistProfile(this.props.artistId),
                getArtistStory(this.props.artistId),
                getArtistBio(this.props.artistId)
            ]).then((results) => {
                const responseArtistProfile = results[0]
                const responseArtistStory = results[1]
                const responseArtistBio = results[2]

                this.setState({
                    avatar: responseArtistProfile.data?.avatar,
                    currVideo: responseArtistProfile.data?.video,
                    image: responseArtistProfile.data?.profile_image,
                    video: responseArtistProfile.data?.video,
                    previewVideo: responseArtistProfile.data?.video,
                })

                if (responseArtistStory.data.body) {
                    const editorState = EditorState.createWithContent(convertFromHTML(responseArtistStory.data.body))
                    const body = convertToRaw(editorState.getCurrentContent())
                    const bodyString = JSON.stringify(body)
                    this.setState({
                        currTitle: responseArtistStory.data.title,
                        title: responseArtistStory.data.title,
                        currStatementTitlePreview: responseArtistStory.data.title,
                        initStory: bodyString,
                        currStatementPreview: responseArtistStory.data.body
                    })
                    this.loadStoryHandler()
                }

                if (responseArtistBio.data.body) {
                    const editorState = EditorState.createWithContent(convertFromHTML(responseArtistBio.data.body))
                    const body = convertToRaw(editorState.getCurrentContent())
                    const bodyString = JSON.stringify(body)
                    //Able to store the rich text now, just need to load the body
                    this.setState({
                        initBio: bodyString,
                        currBioPreview: responseArtistBio.data.body
                    })
                    this.loadBioHandler()
                }
                this.mediaFormRef.current?.setFieldsValue({
                    image:
                        responseArtistProfile.data?.profile_image
                            ? [
                                {
                                    name: getFileNameByUrl(responseArtistProfile.data.profile_image),
                                    status: 'done',
                                    thumbUrl: responseArtistProfile.data.profile_image,
                                    url: responseArtistProfile.data.profile_image
                                }
                            ]
                            : [],
                    avatar:
                        responseArtistProfile.data?.avatar
                            ? [
                                {
                                    name: getFileNameByUrl(responseArtistProfile.data.avatar),
                                    status: 'done',
                                    thumbUrl: responseArtistProfile.data.avatar,
                                    url: responseArtistProfile.data.avatar
                                }
                            ]
                            : [],
                    youtubeURL: responseArtistProfile.data?.video
                })
            }).catch((error) => {
                HttpError(error)
            }).finally(() => {
                this.setState({
                    loading: false
                })
            })
        }
    }

    loadBioHandler = () => {
        this.bioText.current.loadCurr() //ref calls RichTextEditor load method to load the value passed as a prop
    }

    loadStoryHandler = () => {
        this.storyText.current.loadCurr()
        this.setState({
            title: this.state.currTitle
        })
    }

    inputChangeHandler = (e) => {
        //for title
        this.setState({
            title: e.target.value
        })
    }

    videoChangeHandler = (e) => {
        if (e.target.value === '') {
            this.setState({
                video: this.state.currVideo //leaves others unchanged
            })
        } else {
            let profVid = 'https://www.youtube.com/embed/'
            const splitSlash = e.target.value.split('/')
            if (splitSlash.length > 0) {
                profVid = profVid + splitSlash[splitSlash.length - 1]
                this.setState({
                    video: profVid
                })
            }
        }
    }

    editorState2Html = (editorState) => {
        if (editorState.getCurrentContent().hasText()) {
            return convertToHTML(editorState.getCurrentContent())
        }
        return null
    }

    onBioFinish = () => {
        if (!this.props.artistId) return
        const bioEditor = this.bioText.current.state.editorState
        if (bioEditor.getCurrentContent().hasText()) {
            const html = convertToHTML(bioEditor.getCurrentContent())
            const params = {
                body: html,
                artist: this.props.artistId
            }
            patchArtistBio(this.props.artistId, params)
                .then((response) => {
                    message.success('Bio saved successfully').then((r) => {
                    })
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        params.artist = this.props.artistId
                        let postReq = postArtistBio(params)
                        postReq
                            .then((response) => {
                                message.success('Bio created successfully').then((r) => {
                                })
                            })
                            .catch((error) => {
                                HttpError(error)
                            })
                    } else {
                        HttpError(error)
                    }
                })
        }
    }

    onStoryFinish = () => {
        if (!this.props.artistId) return
        const storyEditor = this.storyText.current.state.editorState
        if (storyEditor.getCurrentContent().hasText()) {
            const html = convertToHTML(storyEditor.getCurrentContent())
            const params = {
                title: this.state.title ?? '',
                body: html ?? '',
                artist: this.props.artistId
            }
            let request
            request = patchArtistStory(this.props.artistId, params)
            request
                .then((response) => {
                    message.success('Art statement saved successfully').then((r) => {
                    })
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        params.artist = this.props.artistId
                        let postReq = postArtistStory(params)
                        postReq
                            .then((response) => {
                                message.success('Art statement created successfully').then((r) => {
                                })
                            })
                            .catch((error) => {
                                HttpError(error)
                            })
                    } else {
                        HttpError(error)
                    }
                })
        }
    }

    onFinish = (values) => {
        //actual saving of all values
        this.onBioFinish()
        this.onStoryFinish()
        const {image, avatar, youtubeURL} = values
        //Set the value of the image to be uploaded
        const profImg = image.length === 0 ? null : image[0].response !== undefined ? image[0].response.s3_url : image[0].thumbUrl
        const avatarImg = avatar.length === 0 ? null : avatar[0].response !== undefined ? avatar[0].response.url : avatar[0].thumbUrl
        //Set the value of the video to be uploaded
        let profVid = ''
        if (youtubeURL !== undefined && (youtubeURL.startsWith('https://www.youtube.com') || youtubeURL.startsWith('http://www.youtube.com'))) {
            //clean the formatting of the video link
            let profVidFormat = 'https://www.youtube.com/embed/'
            const splitSlash = youtubeURL.split('/')
            profVid = profVidFormat + splitSlash[splitSlash.length - 1]
            if (profVid === profVidFormat) {
                //set to default none
                profVid = 'https://www.youtube.com/embed/None'
            }
        } else {
            profVid = this.state.currVideo
        }
        const param = {
            profile_image: profImg,
            video: profVid,
            avatar: avatarImg
        }
        let request
        request = patchArtistProfile(this.props.artistId, param)
        request
            .then((response) => {
                message.success('Update profile successful').then((r) => {
                    if (this.is_continue) {
                        this.props.history.push(URL_SHOWCASE_SPOTLIGHTS)
                    }
                })
            })
            .catch((error) => {
                HttpError(error)
            })
    }

    customRequest = (options) => {
        //this occurs on upload, not submit
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    customAvatarRequest = (options) => {
        //this occurs on upload, not submit
        const {onError, onSuccess, file, onProgress} = options
        uploadAvatar(this.props.email, file, onSuccess, onError, onProgress)
    }

    showModal = () => {
        this.setState({
            modalIsVisible: true
        })
    }

    handleOk = () => {
        this.setState({
            modalIsVisible: false
        })
    }

    handleCancel = () => {
        this.setState({
            modalIsVisible: false
        })
    }

    getValueFromEventHandler = (e) => {
        if (e.file.response !== undefined) {
            this.setState({image: e.file.response.s3_url})
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    getAvatarValueFromEventHandler = (e) => {
        if (e.file.response !== undefined) {
            this.setState({avatar: e.file.response.url})
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    render() {
        const layer1Style = {
            width: '100%',
            height: 320,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        }

        function getProfileImageUploadLayout(ins, state) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}

            let span = 24
            const myStyle = {
                marginBottom: 24,
                borderRadius: 12,
                height: 320,
                backgroundImage: `url(${state.image})`,
            }
            return (
                <>
                    {state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={span} style={layer1Style}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <Row style={{paddingLeft: 24, paddingRight: 24, ...style1}}>
                        <Col span={span} style={{...layer1Style, ...myStyle, border: '3px grey dotted'}}>
                        </Col>
                        <Col span={24}>
                            <Form.Item name='image' valuePropName='fileList'
                                       getValueFromEvent={ins.getValueFromEventHandler}
                                       style={{display: 'flex', justifyContent: 'center'}}>
                                <Upload
                                    accept='image/*'
                                    style={{marginLeft: 'auto', marginRight: 'auto'}}
                                    customRequest={ins.customRequest}
                                    maxCount={1}
                                    onChange={({file}) => {
                                        if (file.status === 'remove') {
                                            ins.setState({
                                                image: null
                                            })
                                        } else if (file.status === 'done') {
                                            ins.setState({
                                                image: file.response.s3_url
                                            })
                                        }
                                    }}
                                > <Button icon={<UploadOutlined/>} style={{margin: 'auto'}}>Click to upload banner
                                    image</Button>
                                    {!ins.state.image && (
                                        <p/>
                                    )}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )
        }

        function getProfileAvatarUploadLayout(ins, state) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}
            return (
                <>
                    {state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={24} style={{...layer1Style, height: 359}}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <Row style={{paddingLeft: 24, paddingRight: 24, ...style1}}>
                        <Col span={24} style={{
                            ...layer1Style, height: 465, flexDirection: 'column', gap: 12,
                            justifyContent: 'center', alignItems: 'center'
                        }}>
                            <Avatar src={ins.state.avatar} style={{
                                width: 256, height: 256, display: 'block',
                                marginTop: 36
                            }}/>
                            <Form.Item name='avatar' valuePropName='fileList'
                                       getValueFromEvent={ins.getAvatarValueFromEventHandler} style={{
                                display: 'flex', flexDirection: 'column',
                                justifyContent: 'center', alignItems: 'center'
                            }}>
                                <Upload
                                    accept='image/*'
                                    style={{marginLeft: 'auto', marginRight: 'auto'}}
                                    customRequest={ins.customAvatarRequest}
                                    maxCount={1}
                                    onChange={({file}) => {
                                        if (file.status === 'remove') {
                                            ins.setState({
                                                avatar: null
                                            })
                                        } else if (file.status === 'done') {
                                            ins.setState({
                                                avatar: file.response.url
                                            })
                                        }
                                    }}
                                >
                                    <Button icon={<UploadOutlined/>} style={{margin: 'auto', marginTop: 88}}>Click to
                                        upload
                                        profile
                                        photo</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )
        }

        function getVideoLayout(ins) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}
            return (
                <div>
                    {ins.state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={24} style={{...layer1Style, height: 362}}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <div style={style1}>
                        <Form.Item name='youtubeURL' label='Youtube Video Link: ' labelCol={{span: 24}}
                                   style={{padding: 24}}>
                            <Input style={{display: 'flex'}} placeholder='Enter YouTube Share Link'
                                   onChange={ins.videoChangeHandler}
                                   rules={[
                                       {
                                           required: false,
                                       },
                                       {
                                           type: 'url',
                                           warningOnly: true,
                                       },
                                       {
                                           type: 'string',
                                           min: 6,
                                       }]}/>
                        </Form.Item>
                        <Button style={{float: 'right'}} onClick={() => {
                            ins.setState({
                                previewVideo: ins.state.video
                            })
                        }}>Preview</Button>
                        <Button type='link' onClick={ins.showModal}>
                            Video not showing in preview?
                        </Button>
                    </div>
                </div>
            )
        }

        function getBioEditLayout(ins) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}

            return (
                <div>
                    {ins.state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={24} style={{...layer1Style, height: 362}}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <div style={style1}>
                        <RichTextEditor ref={ins.bioText} toLoad={ins.state.initBio}/>
                    </div>
                </div>
            )
        }

        function getStatementEditLayout(ins) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}

            return (
                <div>
                    {ins.state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={24} style={{...layer1Style, height: 362}}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <div style={style1}>
                        <Input value={ins.state.title} addonBefore='Title' onChange={ins.inputChangeHandler}
                               ref={ins.titleText}
                               style={{wordBreak: 'break-all', width: '100%', overflowX: 'hidden'}}/>
                        <p/>
                        <RichTextEditor ref={ins.storyText} toLoad={ins.state.initStory}/>
                        <p/>
                    </div>
                </div>
            )
        }

        return (
            <div className='site-layout-background'>
                <Modal title='Troubleshooting' visible={this.state.modalIsVisible} onOk={this.handleOk}
                       onCancel={this.handleCancel}>
                    <div>
                        1. Make sure you are using your YouTube video&apos;s Share Link and not the URL. Find this
                        link by clicking &apos;Share&apos;
                        from your YouTube video, and copying the link.
                    </div>
                    <div>2. If this still did not work, send us a message, and we will work on fixing this right
                        away.
                    </div>
                </Modal>
                <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}
                     style={{marginTop: 12, justifyContent: "space-between"}}>
                    <Col style={{display: 'table', textAlign: "center", height: '100%'}}>
                        <Title level={1} style={{
                            marginBottom: 12,
                            marginTop: 12
                        }}>Basic Info</Title>
                    </Col>
                </Row>
                <Form colon={false} labelAlign='left' onFinish={this.onFinish} ref={this.mediaFormRef}>
                    <Row gutter={12} style={{marginTop: 24}}>
                        <Col xs={24} xl={12}>
                            <Card>
                                <Divider orientation='left' style={{fontSize: 16}}>
                                    Showcase Banner <span style={{color: 'red'}}>*</span>{' '}
                                </Divider>
                                <p>
                                    <i>
                                        Use an image that represents you and your art. We recommend that you use a
                                        horizontal photo of yourself in your studio or your favorite art.{' '}
                                        <a style={{color: 'black', textDecoration: 'underline'}} target={'_blank'}
                                           rel={'noreferrer'}
                                           href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
                                            Learn More
                                        </a>
                                        .
                                    </i>
                                </p>
                                <br/>
                                {getProfileImageUploadLayout(this, this.state)}
                            </Card>
                        </Col>
                        <Col xs={24} xl={12}>
                            <Card>
                                <Divider orientation='left' style={{fontSize: 16}}>
                                    Profile Photo <span style={{color: 'red'}}>*</span>{' '}
                                </Divider>
                                <p>
                                    <i>
                                        Use a profile photo to help audiences find you.{' '}
                                        <a style={{color: 'black', textDecoration: 'underline'}} target={'_blank'}
                                           rel={'noreferrer'}
                                           href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
                                            Learn More
                                        </a>
                                        .
                                    </i>
                                </p>
                                {getProfileAvatarUploadLayout(this, this.state)}
                            </Card>
                        </Col>
                    </Row>
                    <Card>
                        <Row gutter={[24, 24]}>
                            <Col span={24}>
                                <Divider orientation='left'>
                                    Bio <span style={{color: 'red'}}>*</span>
                                </Divider>
                                <p>
                                    <i>
                                        Write a short introduction about yourself.{' '}
                                        <a style={{color: 'black', textDecoration: 'underline'}} target={'_blank'}
                                           rel={'noreferrer'}
                                           href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
                                            Learn More
                                        </a>
                                        .
                                    </i>
                                </p>
                            </Col>
                            <Col xs={24} xl={12}>
                                <div style={{display: 'flex'}}>
                                    <Button style={{marginLeft: 'auto', marginRight: 0}} onClick={() => {
                                        if (this.storyText?.current) {
                                            const bio = convertToHTML(this.bioText.current.state.editorState.getCurrentContent())
                                            this.setState({
                                                currBioPreview: bio
                                            })
                                        }

                                    }}>Preview</Button>
                                </div>
                                {getBioEditLayout(this)}
                            </Col>
                            <Col xs={24} xl={12} style={{paddingLeft: 24, paddingRight: 24}}>
                                <Row style={{borderRadius: 3, border: '1px dashed grey', height: '100%', padding: 24}}>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <h1 style={{
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            paddingBottom: 12,
                                            width: '100%'
                                        }}>About</h1>
                                        {this.state.currBioPreview && (
                                            <div style={{wordBreak: 'break-all', 'width': '100%'}}
                                                 dangerouslySetInnerHTML={{__html: this.state.currBioPreview}}></div>
                                        )}
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                    <Card>
                        <Row gutter={[12, 12]} style={{minHeight: 540}}>
                            <Divider orientation='left' style={{fontSize: 16}}>Art Story Video</Divider>
                            <Col xs={24} lg={12}>
                                <p>
                                    <i>
                                        Use a video to introduce yourself, your unique art process, favorite
                                        collections, or your
                                        story as an artist. We support
                                        YouTube and Vimeo share link.{' '}
                                        <a style={{color: 'black', textDecoration: 'underline'}} target={'_blank'}
                                           rel={'noreferrer'}
                                           href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
                                            Learn More
                                        </a>
                                        .
                                    </i>
                                </p>
                                {getVideoLayout(this)}
                            </Col>
                            <Col xs={24} lg={12} style={{padding: 24}}>
                                <iframe
                                    width="100%"
                                    height="480"
                                    src={this.state.previewVideo}
                                    title="Youtube Player"
                                    frameBorder="0"
                                    allowFullScreen
                                />
                            </Col>
                        </Row>
                    </Card>
                    <Card>
                        <Row gutter={12}>
                            <Col span={24}>
                                <Divider orientation='left' style={{fontSize: 16}}>Art Statement</Divider>
                                <p>
                                    <i>
                                        Tell the audiences about your art&apos;s inspiration, purpose, unique process,
                                        and
                                        story behind
                                        the works.{' '}
                                        <a style={{color: 'black', textDecoration: 'underline'}} target={'_blank'}
                                           rel={'noreferrer'}
                                           href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
                                            Learn More
                                        </a>
                                        .
                                        <br/>
                                        <a target={'_blank'} style={{ display: 'block', marginTop: '24px', color: 'black', textDecoration: 'underline' }} href={URL_WRITER_STATEMENT}>
                                            Need help to write the statement?
                                          </a>
                                    </i>
                                </p>
                            </Col>
                            <Col xs={24} xl={12}>
                                <div style={{display: 'flex'}}>
                                    <Button type={'ghost'} style={{marginLeft: 'auto', marginRight: 0}} onClick={() => {
                                        if (this.storyText?.current) {
                                            const story = convertToHTML(this.storyText.current.state.editorState.getCurrentContent())
                                            this.setState({
                                                currStatementPreview: story,
                                                currStatementTitlePreview: this.state.title
                                            })
                                        }
                                    }}>Preview</Button>
                                </div>
                                {getStatementEditLayout(this)}
                            </Col>
                            <Col xs={24} xl={12} style={{paddingLeft: 24, paddingRight: 24}}>
                                <Row style={{borderRadius: 3, border: '1px dashed grey', height: '100%', padding: 24}}>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <h1 style={{
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            paddingBottom: 12,
                                            wordBreak: 'break-all',
                                            width: '100%'
                                        }}>
                                            {this.state.currStatementTitlePreview}
                                        </h1>
                                        {this.state.currStatementPreview && (
                                            <div style={{wordBreak: 'break-all', 'width': '100%'}}
                                                 dangerouslySetInnerHTML={{__html: this.state.currStatementPreview}}></div>
                                        )}
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={[32, 16]} style={{
                        backgroundColor: 'rgba(255,255,255,0.4)',
                        position: 'fixed',
                        zIndex: 1000,
                        paddingLeft: 12,
                        paddingRight: 12,
                        justifyContent: 'center',
                        justifyItems: 'center',
                        left: this.props.siderWidth,
                        width: '90%',
                        bottom: 12,
                        alignItems: 'center',
                        flexDirection: "row"
                    }}>
                        <Col xs={24} sm={5} md={5} lg={3}>
                            <BackButton {...this.props} block/>
                        </Col>
                        <Col xs={12} sm={6} md={5} lg={4}>
                            <Button block type='primary' size='middle' htmlType='submit'>
                                Save
                            </Button>
                        </Col>
                        <Col xs={12} sm={8} md={7} lg={6}>
                            <Button
                                onClick={(e) => {
                                    this.is_continue = true
                                }}
                                block
                                type='primary'
                                size='middle'
                                htmlType='submit'
                                style={{float: "right"}}
                            >
                                Save & Continue
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default withRouter(ShowcaseBio)
